import { Button } from '@material-ui/core'
import Pagination from '@material-ui/lab/Pagination'
import PaginationItem from '@material-ui/lab/PaginationItem'
import React from 'react'
import * as styles from './table-pagination-actions.module.less'
import Icon from '../icon/icon'
import cx from 'classnames'

type Props = {
  count: number
  page: number
  rowsPerPage: number
  onChangePage: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, newPage: number) => void
}

const TablePaginationActions = (props: Props) => {
  const { count, page, rowsPerPage, onChangePage } = props
  const numberOfPages = Math.ceil(count / rowsPerPage)

  const handleChange = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, page: number) => {
    onChangePage(event, page - 1)
  }

  const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (page + 1 < numberOfPages) onChangePage(event, page + 1)
  }

  const handlePrevButtonClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (page + 1 > 1) onChangePage(event, page - 1)
  }

  const handleIsSelected = (item: any): boolean => {
    return item.page === page + 1
  }

  return (
    <div className={styles.paginationActions}>
      <Button aria-label="previous" onClick={handlePrevButtonClick} size="small" className={styles.buttonPrevious}>
        <Icon name="sm-left" className={styles.icon} />
      </Button>
      <Pagination
        count={numberOfPages}
        renderItem={(item: any) => {
          const isHandleSelected = handleIsSelected(item)
          const pageClass = isHandleSelected ? styles.paginationItemSelected : styles.paginationItem
          const largePageClass = isHandleSelected
            ? styles.paginationItemSelectedLarge
            : styles.paginationItemLarge
          const extraLargePageClass = isHandleSelected
            ? styles.paginationItemSelectedExtraLarge
            : styles.paginationItemExtraLarge
          return (
            <PaginationItem
              {...item}
              data-testid="pagination-item"
              component="button"
              selected={handleIsSelected(item)}
              variant="text"
              shape="rounded"
              page={item.page}
              onClick={e => handleChange(e, item.page)}
              size="small"
              className={cx({
                [pageClass]: item.page < 10000,
                [largePageClass]: item.page > 9999 && item.page < 100000,
                [extraLargePageClass]: item.page > 99999,
              })}
            />
          )
        }}
        page={page + 1}
        hidePrevButton
        hideNextButton
        defaultPage={1}
      />
      <Button aria-label="next" onClick={handleNextButtonClick} size="small" className={styles.buttonNext}>
        <Icon name="sm-right" className={styles.icon} />
      </Button>
    </div>
  )
}

export default TablePaginationActions
